
import './App.css';
import Privacy from './pages/privacy';
import {BrowserRouter, Route, Routes, Navigate} from "react-router-dom";
import PrivacyDriverApp from './pages/privacy_driverapp';
import TermsOfUsage from './pages/terms_of_usage';



function App() {

    return (
      <BrowserRouter>
        <Routes>
          <Route path="/" element={ <Navigate to="/privacy" /> } />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/privacy-driverapp" element={<PrivacyDriverApp />} />
          <Route path="/terms-of-usage" element={<TermsOfUsage />} />
        </Routes>
      </BrowserRouter>
  )
}

export default App;
